<span [dir]="options.dir!">
  <mat-sidenav-container
    class="mainWrapper"
    autosize
    autoFocus
    [ngClass]="{
      'sidebarNav-mini': options.sidenavCollapsed && options.navPos !== 'top' && !resView,
      'sidebarNav-horizontal': options.horizontal,
      cardBorder: options.cardBorder
    }"
  >
    <!-- ============================================================== -->
    <!-- Vertical Sidebar -->
    <!-- ============================================================== -->
    <mat-sidenav
      #leftSidenav
      [mode]="isOver ? 'over' : 'side'"
      [opened]="options.navPos === 'side' && options.sidenavOpened && !isOver && !resView"
      (openedChange)="onSidenavOpenedChange($event)"
      (closedStart)="onSidenavClosedStart()"
      class="sidebarNav"
      (mouseenter)="stateChanged(true)"
      (mouseleave)="stateChanged(false)"
    >
      <div class="flex-layout">
        <app-sidebar
          [class]="sideNavClass"
          [showToggle]="isOver"
          [isCollapsed]="options.sidenavCollapsed"
          (toggleCollapsed)="toggleCollapsed()"
          (toggleMobileNav)="sidenav.toggle()"
        ></app-sidebar>
        <ng-scrollbar class="position-relative" style="height: 100%">
          <mat-nav-list class="sidebar-list">
            @for (item of navItems; track item) {
              <app-nav-item
                [isCollapsed]="options.sidenavCollapsed"
                [item]="item"
                (notify)="sidenav.toggle()"
                class="top-parent"
              ></app-nav-item>
            }
          </mat-nav-list>
        </ng-scrollbar>
      </div>
    </mat-sidenav>

    <!-- ============================================================== -->
    <!-- Main Content -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="contentWrapper" #content>
      <!-- ============================================================== -->
      <!-- VerticalHeader -->
      <!-- ============================================================== -->
      <app-header
        [showToggle]="!isOver"
        (toggleCollapsed)="toggleCollapsed()"
        (toggleMobileNav)="sidenav.toggle()"
        (toggleMobileFilterNav)="toggleFilterNav()"
      />

      <main class="pageWrapper" [ngClass]="{ maxWidth: options.boxed }">
        <app-breadcrumb/>
        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
        <div class="pb-[55px]">
          <router-outlet></router-outlet>
        </div>
        <footer class="text-center fixed bottom-0 py-4 right-0 w-full text-sm border-t border-t-[#d7dde2] bg-white/90! backdrop-blur-sm dark:bg-[#141a21]/40!">
          {{ 'copy right' | translate:{ year: currentYear } }}
        </footer>
      </main>

      <!-- ------------------------------------------------------------------
          Mobile Apps Sidebar
          ------------------------------------------------------------------ -->
      <div [class.open]="isFilterNavOpen" class="filter-sidebar">
        <div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="branding">
              @if (options.theme === 'light') {
                <a href="/">
                  <img src="./assets/images/logos/dark-logo.svg" class="m-2 align-middle" alt="logo" />
                </a>
              } @else {
                <a href="/">
                  <img src="./assets/images/logos/light-logo.svg" class="m-2 align-middle" alt="logo" />
                </a>
              }
            </div>
          </div>

          <mat-accordion>
            <mat-expansion-panel class="shadow-none">
              <mat-expansion-panel-header>
                <mat-panel-title class="f-s-16 f-w-500">Apps</mat-panel-title>
              </mat-expansion-panel-header>
              <div>
                <div class="row">
                  @for (appdd of apps; track appdd.img) {
                    <div class="col-12 text-hover-primary">
                      <a [routerLink]="[appdd.link]" class="gap-16 d-flex align-items-center text-decoration-none m-b-24">
                        <button mat-mini-fab class="rounded shadow-none text-primary bg-light-primary">
                          <img [src]="appdd.img" width="20" />
                        </button>

                        <div>
                          <h5 class="m-0 f-s-14 f-w-600 textprimary hover-text">
                            {{ appdd.title }}
                          </h5>
                          <span class="f-s-14 f-s-12">{{ appdd.subtitle }}</span>
                        </div>
                      </a>
                    </div>
                  }
                </div>
                <h4 class="f-s-18 f-w-600 m-b-16">Quick Links</h4>
                @for (quicklink of quicklinks; track quicklink.title) {
                  <div class="text-hover-primary">
                    <a [routerLink]="[quicklink.link]" class="hover-text text-decoration-none f-s-14 f-w-600 d-block p-y-8">
                      {{ quicklink.title }}
                    </a>
                  </div>
                }
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </mat-sidenav-content>

    <mat-sidenav #customizerRight mode="over" position="end">
      <div class="p-x-16 p-y-20 d-flex align-items-center justify-content-between">
        <h3 class="f-s-21 f-w-600">Settings</h3>
        <button class="d-lg-none" mat-button (click)="customizerRight.toggle()">Close</button>
      </div>
      <mat-divider></mat-divider>
    </mat-sidenav>
  </mat-sidenav-container>
</span>
